import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { StampHistoryRow } from '@models/stamp';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    history: StampHistoryRow;
}

function StampHistory({ history }:Props) {
    const { t } = useTranslation('stamp');
    const {
        stampCount, shopName, shopGroupName, occurredAt, eventType,
    } = history;
    const isNegative = eventType !== 'ISSUED';
    const displayName = useMemo(() => {
        switch (eventType) {
        case 'ISSUED':
            return shopName || shopGroupName;
        case 'USED':
            return t('histories.eventType.couponConvert');
        case 'CANCELED':
            return shopName || shopGroupName;
        default:
            return t('histories.eventType.expired');
        }
    }, [shopName, shopGroupName, eventType, t]);

    return (
        <Container>
            <Row fullWidth justify='space-between' align='center'>
                <Text color={isNegative ? colors.textError : colors.textSecondary}
                    fontWeight={isNegative ? 'bold' : 'medium'}>
                    {isNegative && '-'}{stampCount}{t('card.countUnit')}
                </Text>
                <Text color={isNegative ? colors.textError : colors.textSecondary}
                    fontWeight='medium' >
                    {t(`eventType.${eventType}`)}
                </Text>
            </Row>
            <Row fullWidth justify='space-between'>
                <Text color={colors.textUnselected}
                    fontWeight='medium'
                    size='s'>
                    {displayName}
                </Text>
                <Text color={colors.textUnselected}
                    fontWeight='medium'
                    size='s'>
                    {dayjs(occurredAt).format('YYYY.MM.DD')}
                </Text>
            </Row>
        </Container>
    );
}

const Container = styled.div`
    padding: 16px;
    border-radius: 12px;
    background-color: var(--color-white);
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export default StampHistory;
